const $$splitComponentImporter = () => import('/home/runner/work/touring-host-app/touring-host-app/src/routes/_rootLayout/companies/$id.shows.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
/* eslint-disable @typescript-eslint/no-use-before-define */
import { getFindCompanyShowsQueryOptions } from '@api';
import { createTableQuerySchema, getTableParams } from '@common*';
import { createFileRoute } from '@tanstack/react-router';
const TABLE_ID_COMPANY_SHOWS = 'companyShows';
const searchSchema = createTableQuerySchema({
  tableIds: [TABLE_ID_COMPANY_SHOWS]
});
export const Route = createFileRoute('/_rootLayout/companies/$id/shows')({
  validateSearch: search => searchSchema.parse(search),
  beforeLoad: () => ({
    tableIdCompanyShows: TABLE_ID_COMPANY_SHOWS
  }),
  loader: async ({
    context: {
      queryClient
    },
    params,
    location
  }) => {
    const tableParams = getTableParams(location.search, TABLE_ID_COMPANY_SHOWS);
    queryClient.ensureQueryData(getFindCompanyShowsQueryOptions(params.id, tableParams));
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});